// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tag-status[data-v-0d825139]{padding:.5rem 1rem;border-radius:.25rem}.tag-status[type=warning][data-v-0d825139]{background:rgba(247,173,30,.1)}.tag-status[type=success][data-v-0d825139]{background:rgba(0,184,73,.1)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
